// src/firebaseConfig.js
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyDRU4wcl3re3fIRyKOEJFCJASJUM8U1J38",
    authDomain: "raindropexplorer.firebaseapp.com",
    projectId: "raindropexplorer",
    storageBucket: "raindropexplorer.appspot.com",
    messagingSenderId: "266460489658",
    appId: "1:266460489658:web:9e1423362d57512dc89f83",
    measurementId: "G-ABCDEFG"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const functions = getFunctions(app);

export { app, functions, httpsCallable };